import { ICountry, IState } from '@checkout/state';
import * as cx from 'classnames';
import * as React from 'react';
import { ChangeEvent, FocusEvent } from 'react';
import { FieldMessage } from '..';
import * as Styles from './DropDown.scss';

interface IOwnProps {
  id: string;
  name?: string;
  options: any[];
  value: any;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  errors?: {};
  touched?: any;
  sizeVariant?: 'large' | 'medium' | 'small' | 'half';
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
  onBlur?: (event: FocusEvent<HTMLSelectElement>) => void;
  valueSelector: (item: ICountry & IState) => string | undefined;
  placeholder?: string;
  readOnly?: boolean;
}
const DropDown: React.SFC<IOwnProps> = (props) => {
  const { id, name, options, label, readOnly, placeholder, disabled, required, onChange, onBlur, value, valueSelector, sizeVariant, errors, touched } = props;

  const componentClassNames = cx({ // TODO - probably better will be build wrapper for component (same style used for TextInput)
    [Styles.component]: true,
    [Styles.withLabel]: label !== undefined,
    [Styles.readOnly]: readOnly,
    [Styles.disabled]: disabled,
    [Styles.small]: !readOnly && sizeVariant === 'small',
    [Styles.medium]: !readOnly && sizeVariant === 'medium',
    [Styles.half]: !readOnly && sizeVariant === 'half',
  });

  const dropDownClassNames = cx({
    [Styles.select]: true,
    [Styles.error]: errors && touched
  });

  const getOptionName = (dropDownOptions: any[], selectedOptionValue: string) => {
    return dropDownOptions.filter((option) => valueSelector(option) === selectedOptionValue)[0];
  };

  if ((!value && readOnly) || options === undefined) { return null; }

  return (
    <div className={componentClassNames}>
      {!readOnly && (
        <div className={Styles.inner}>
          {label && <label className={Styles.label} htmlFor={id}>{required ? `${label}*` : label}</label>}
          <select
            id={id}
            name={name}
            value={value}
            title={placeholder}
            className={dropDownClassNames}
            required={required}
            disabled={readOnly || disabled}
            onChange={onChange}
            onBlur={onBlur}
          >
            {!value && placeholder && <option value="" hidden={true}>{placeholder}</option>}
            {options && options.map(option => (
              <option key={valueSelector(option)} value={valueSelector(option)}>
                {option.name}
              </option>
            ))}
          </select>
        </div>
      )}
      {readOnly && (
        <span>{getOptionName(options, value).name}</span>
      )}
      {errors && touched && (
        <span className={Styles.errorWrapper}>
          <FieldMessage error={true} message={errors} />
        </span>
      )}
    </div>
  );
};

export default DropDown;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/DropDown/DropDown.tsx